import { ChangeEvent, useEffect, useState } from "react";
import InputBase from "@mui/material/InputBase";
import { CloseRounded } from "@mui/icons-material";
import SearchIcon from "@icons/Search";
import { SearchBoxProps } from "./interface";
import useStyles from "./styles";
import { useDebounce } from "@utils/useDebounce";

const SearchBox: React.FC<SearchBoxProps> = (props) => {
  const { value: _value, onChange: _onChange } = props;
  const [value, setValue] = useState("");
  const classes = useStyles();
  const debounceSearch = useDebounce(value);

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    _onChange(event.target.value);
    setValue(event.target.value);
  };

  const onDelete = () => {
    _onChange("");
    setValue("");
  };

  useEffect(() => {
    if (value !== _value) _onChange(value);
  }, [debounceSearch]);

  return (
    <InputBase
      {...props}
      className={classes.root}
      inputProps={{ "data-testid": "searchbox" }}
      onChange={onChange}
      value={value}
      startAdornment={<SearchIcon className={classes.icon} />}
      endAdornment={
        value || _value ? <CloseRounded data-testid="close-button" fontSize="small" className={classes.deleteIcon} onClick={onDelete} /> : null
      }
    />
  );
};

export default SearchBox;
